// Tolerance instead of `=== 0.5`: floats leave residual IEEE error on non-terminating fractions.
const HALFWAY_EPSILON = 1e-9;

export function roundHalfEven(value: number, fractionDigits: number): number {
    if (!Number.isFinite(value)) return value;

    const factor = Math.pow(10, fractionDigits);
    const scaled = value * factor;
    const floor = Math.floor(scaled);
    const diff = scaled - floor;

    let roundedInt: number;
    if (Math.abs(diff - 0.5) < HALFWAY_EPSILON) {
        roundedInt = floor % 2 === 0 ? floor : floor + 1;
    } else if (diff > 0.5) {
        roundedInt = floor + 1;
    } else {
        roundedInt = floor;
    }

    return roundedInt / factor;
}
